import { Link } from "react-router-dom";
import { LOGO_WHITE } from "../lib/api";

export default function Footer() {
    const year = new Date().getFullYear();
    return (
        <footer className="bg-black text-white pt-24 pb-10 border-t border-white/10" data-testid="footer">
            <div className="container-nm">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-14">
                    <div className="md:col-span-5">
                        <img src={LOGO_WHITE} alt="N&M Management" className="h-12 w-auto mb-6" />
                        <p className="text-white/60 text-base md:text-lg max-w-md leading-relaxed">
                            Format originali, eventi memorabili, contenuti di marca. Per brand
                            e broadcaster.
                        </p>
                        <Link
                            to="/contatti"
                            className="inline-flex items-center gap-2 mt-8 kicker text-white hover:text-[color:var(--brand-accent)] transition-colors"
                            data-testid="footer-cta-contact"
                        >
                            Parla con noi →
                        </Link>
                    </div>

                    <div className="md:col-span-3">
                        <div className="kicker text-white/50 mb-5">Navigazione</div>
                        <ul className="space-y-3">
                            {[
                                ["/", "Home"],
                                ["/produzioni-tv", "Produzioni TV"],
                                ["/eventi", "Eventi"],
                                ["/comunicazione", "Comunicazione"],
                                ["/talent-ospiti", "Talent & Ospiti"],
                                ["/contatti", "Contatti"],
                            ].map(([to, label]) => (
                                <li key={to}>
                                    <Link to={to} className="text-white/80 hover:text-white">
                                        {label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="md:col-span-4">
                        <div className="kicker text-white/50 mb-5">N&M Management srl</div>
                        <ul className="space-y-2 text-white/75 text-[15px] leading-relaxed">
                            <li>
                                <span className="text-white/45">Sede legale</span><br />
                                Galleria Cosimo Fanzago, 3<br />
                                24121 Bergamo
                            </li>
                            <li className="pt-2">
                                <span className="text-white/45">Sede operativa</span><br />
                                Via T. Tasso, 35<br />
                                24121 Bergamo
                            </li>
                            <li className="pt-2">
                                <span className="text-white/45">P. IVA</span> 09224470964
                            </li>
                            <li className="pt-2">
                                <a href="mailto:segreteria@nemmanagement.it" className="hover:text-white">
                                    segreteria@nemmanagement.it
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="mt-20 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-white/45">
                    <span>© {year} N&M Management srl · Tutti i diritti riservati</span>
                    <div className="flex flex-wrap gap-x-6 gap-y-2">
                        <Link to="/privacy" className="hover:text-white" data-testid="footer-privacy">
                            Privacy Policy
                        </Link>
                        <Link to="/cookies" className="hover:text-white" data-testid="footer-cookies">
                            Cookie Policy
                        </Link>
                        <Link to="/admin/login" className="hover:text-white" data-testid="footer-admin-link">
                            Area riservata
                        </Link>
                    </div>
                </div>
            </div>
        </footer>
    );
}
